import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Flex, Box } from 'reflexbox/styled-components'

import { H2 } from 'lib/ui/primitives'
import media from 'media'
import theme from 'theme'

export const CLASS_NAME_TITLE = 'section-header-title'

const SolutionsHeader = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
  justifyContent: ['flex-start', 'flex-start', 'space-between'],
  mb: [50],
})``

const DescriptionContainer = styled(Box).attrs({
  mt: [16, 16, 0],
  fontSize: 18,
  width: [1, 1, 0.45, 0.5],
})`
  ${media.desktop`
    max-width: 450px;
    width: 50%;
`}
`

export default function SectionHeader ({
  title,
  semanticTitleTag,
  styleTitleComponent,
  descriptionText,
  renderDescriptionAction,
  ...others
}) {
  const Title = styled(styleTitleComponent).attrs({
    className: CLASS_NAME_TITLE,
    as: semanticTitleTag,
  })`
    width: 100%;
    font-weight: ${theme.fontWeights.bold};

    ${media.desktop`
    width: 45%;
  `}

    ${media.giant`
    width: 50%;
  `}
  `

  return (
    <SolutionsHeader {...others}>
      <Title>{title}</Title>
      {descriptionText && (
        <DescriptionContainer>
          <p>{descriptionText}</p>
          {renderDescriptionAction && renderDescriptionAction()}
        </DescriptionContainer>
      )}
    </SolutionsHeader>
  )
}

SectionHeader.defaultProps = {
  semanticTitleTag: 'h2',
  styleTitleComponent: H2,
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionText: PropTypes.string.isRequired,
  renderDescriptionAction: PropTypes.func,
  semanticTitleTag: PropTypes.string,
  styleTitleComponent: PropTypes.elementType,
}
